module.exports = __webpack_public_path__ + "img/blaze@2x.23943842.png";